import { render } from "./escolaEditar.vue?vue&type=template&id=7f35224b&scoped=true"
import script from "./escolaEditar.vue?vue&type=script&lang=js"
export * from "./escolaEditar.vue?vue&type=script&lang=js"

import "./escolaEditar.vue?vue&type=style&index=0&id=7f35224b&scoped=true&lang=css"
import "./escolaEditar.vue?vue&type=style&index=1&id=7f35224b&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f35224b"]])

export default __exports__